<button mat-button class="w-100" [disabled]="valid" (click)="onClick()" [class]="theme.myIconBgColor">
        <mat-icon [class]="theme.myIconColor">{{icon}}</mat-icon> {{title}}
</button>